let urls = {
  index:{
    //首页列表
    img: "/imggroups-service/cs/image.apec",//全部图片
    // imgPage: '/imggroups-service/cs/imageByPage.apec',//图片分页查询
    // breed:"/JS-GOODSEXTEND-SERVICE/aSpec/breeds.apec",//查询所有品种规格
    // IndianTable:'/ORDERCSEN-SERVICE/indiaTradeInfo/queryAll.apec',//印度行情表格数据
    priceTrend:'/ORDERCSEN-SERVICE/publishTips/queryTrend.apec',//价格走势
    IndianTable: '/QUOTATION-SERVER/quotation/obtainQuotationList.magpie', // 大宗-印度行情
    // dealTrend:'/ORDERCSEN-SERVICE/publishTips/queryRecentTips.apec',//成交动态
    // goodsSearchPage:'/JS-GOODSNOZZLE-SERVICE/jsWebGoodsInfo/searchPage.apec',//采购和供应商品分页
    // goodsSearch:'/JS-GOODSNOZZLE-SERVICE/jsWebGoodsInfo/qryWebGoodsInfo.apec',//采购和供应商品所有
    goodsSearch:'/EMALL-SERVICE/esExternal/queryByKeyWords.magpie',//采购和供应商品所有
  },
  article:{
  	// article:'/NOTICE-SERVICE/cs/noticeList.apec',//文章不分页
    articlePage:'/NOTICE-SERVICE/cs/selectListByPage.apec',//查询文章分页
    // detail:'/NOTICE-SERVICE/cs/noticeDetail.apec',//文章详情
    searchPage:'/elastic-search-service/notice/search.apec',//按标题搜索分页
    // 资讯
    article: '/information-service/information/query.magpie', // 资讯平台-资讯文章列表
    detail:'/information-service/information/detail.magpie', // 资讯平台-资讯文章详细
  },
  spot:{
    list: '/EMALL-SERVICE/esExternal/queryByKeyWords.magpie', // 挂牌列表
    detail: '/LISTING-SERVICE/ListingProjectApp/detail.magpie', // 挂牌详情
    addOrder: '/LISTING-SERVICE/ListingOrderWithApp/addOrder.magpie', // 挂牌下单
  },
  help:{
  	// advice:'/DOCUMENT-SERVICE/comment/addComment.apec'//提交意见反馈
  },
  login: {
    login: '/SSO-SERVER/app/token', // 登录
    register: '/USER-SERVER/appuser/register.magpie', // 注册
    sendCode: '/USER-SERVER/appuser/smsCode.magpie', // 发送验证码
    checkCode: '/USER-SERVER/appuser/checkCode.magpie', // 检验验证码
    resetPwd: '/USER-SERVER/appuser/resetPwd.magpie', // 重置密码
  },
  user: {
    info: '/USER-SERVER/appoauthinfo/authUserDetail.magpie', // 个人信息查询
    orderList: '/LISTING-SERVICE/ListingOrder/queryMyOrderList.magpie', // 订单列表查询、
    orderDetail: '/LISTING-SERVICE/ListingOrderWithApp/viewTradeOrder.magpie', // 订单详情
  },
  common: {
    variety: '/BASE-VARIETY/ext/getVarietySelect.magpie', // 获取品种
    market: '/BASE-DATADICT/extbasedatadict/getSelect.magpie', // 获取市场
  }
};

export default urls;



// WEBPACK FOOTER //
// ./src/api/url.js